import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../contexts/LanguageContext';

const PopupOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${props => props.$show ? 1 : 0};
  visibility: ${props => props.$show ? 'visible' : 'hidden'};
  transition: all 0.3s ease;
`;

const PopupContent = styled.div`
  background: var(--popup-bg);
  padding: 3rem 2rem;
  border-radius: 20px;
  text-align: center;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  transform: ${props => props.$show ? 'scale(1)' : 'scale(0.8)'};
  transition: transform 0.3s ease;
`;

const Title = styled.h2`
  color: var(--brand-primary);
  margin-bottom: 1rem;
  font-size: 1.5rem;
`;

const Subtitle = styled.p`
  color: var(--text-secondary);
  margin-bottom: 2rem;
  font-size: 1rem;
`;

const LanguageOptions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: center;
  }
`;

const LanguageOption = styled.button`
  background: var(--bg-elevated);
  border: 3px solid var(--border-primary);
  border-radius: 15px;
  padding: 1.5rem 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  min-width: 120px;

  &:hover {
    border-color: var(--brand-primary);
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(44, 85, 48, 0.2);
  }

  &:active {
    transform: translateY(-2px);
  }
  
  @media (max-width: 480px) {
    flex-direction: row;
    width: 200px;
    justify-content: center;
    padding: 1rem;
  }
`;

const FlagIcon = styled.span`
  font-size: 2.5rem;
  margin-bottom: 0.5rem;
  
  @media (max-width: 480px) {
    font-size: 1.5rem;
    margin-bottom: 0;
  }
`;

const LanguageName = styled.span`
  font-weight: 600;
  color: var(--text-primary);
  font-size: 1rem;
`;

const LanguagePopup = () => {
  const { showLanguagePopup, switchLanguage, setShowLanguagePopup } = useLanguage();

  const handleLanguageSelect = (lang) => {
    switchLanguage(lang);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      // If user clicks outside without selecting, default to English
      switchLanguage('en');
    }
  };

  return (
    <PopupOverlay $show={showLanguagePopup} onClick={handleOverlayClick}>
      <PopupContent $show={showLanguagePopup}>
        <Title>Choose Your Language / Chọn ngôn ngữ</Title>
        <Subtitle>Select your preferred language / Chọn ngôn ngữ ưa thích của bạn</Subtitle>
        <LanguageOptions>
          <LanguageOption onClick={() => handleLanguageSelect('en')}>
            <FlagIcon>🇺🇸</FlagIcon>
            <LanguageName>English</LanguageName>
          </LanguageOption>
          <LanguageOption onClick={() => handleLanguageSelect('vi')}>
            <FlagIcon>🇻🇳</FlagIcon>
            <LanguageName>Tiếng Việt</LanguageName>
          </LanguageOption>
        </LanguageOptions>
      </PopupContent>
    </PopupOverlay>
  );
};

export default LanguagePopup;